import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { WorkshopWeeklyUsage } from '../../WeeklyUsage';
import { TitleText } from '../sharedComponents';
import svgMap from '../svgs/Common/svgMap';

const WeeklyUsage = ({ titleId, anyProgress, dialogs }) => {
  const modalTitle = anyProgress ? 'Welcome Back' : 'Welcome';

  return (
    <>
      <StyledTitle id={titleId}>{modalTitle}</StyledTitle>
      <StyledWeeklyUsageContent questMessages={dialogs} />
    </>
  );
};

WeeklyUsage.propTypes = {
  titleId: PropTypes.string.isRequired,
  anyProgress: PropTypes.bool,
  dialogs: PropTypes.array,
};

WeeklyUsage.defaultProps = {
  anyProgress: false,
  dialogs: [],
};

export default WeeklyUsage;

const StyledTitle = styled(TitleText)`
  width: 195px;
  z-index: 1;
  transform: translate(-50%, 0);
  top: 87px;
  left: 50%;
  font-size: 23px;
  letter-spacing: 0;
`;

const StyledWeeklyUsageContent = styled(WorkshopWeeklyUsage)`
  width: 672px;
  height: 430px;
  padding: 80px 40px 60px;
  transform: translate(-50%, 0);
  position: absolute;
  top: 55px;
  left: 50%;
  background-color: #d9d9d9;
  background-image: url(${svgMap.LargeParchmentPanel});
  background-position: center;
  background-color: transparent;
  background-repeat: no-repeat;
  background-size: contain;
`;
